import { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../redux/store';
import {
    ProjectSidepanel,
    setActiveDocument,
    setActiveSidepanel,
} from '../redux/project/sliceProjectSidepanel';

/**
 * Hook that opens the Sidepanel for documents and additional documents.
 */
export const useOpenSidePanel = ({
    UniversalId,
    NoteId,
    disableClick,
}: IOpenSidepanelSettings): ((e: React.MouseEvent, sidepanel: ProjectSidepanel) => void) => {
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Get relevant values from Redux store. */
    const active = useSelector((store: IAppReduxStore) => store.projectSidepanel.active);
    const targetDocId = useSelector((store: IAppReduxStore) => store.projectSidepanel.targetDocId);

    /**
     * Opens the sidepanel when the user clicks on the component element.
     */
    return (e: React.MouseEvent, sidepanel: ProjectSidepanel) => {
        if (disableClick) {
            return;
        }

        e.stopPropagation();

        /** Close sidepanel if user clicks on the same icon. */
        if (sidepanel === active && targetDocId === UniversalId) {
            dispatch(setActiveSidepanel(ProjectSidepanel.None));

            return;
        }

        dispatch(setActiveDocument({ UniversalId, NoteId }));
        dispatch(setActiveSidepanel(sidepanel));
    };
};

/**
 * Interface that describes the props for the useOpenSidePanel hook.
 */
export interface IOpenSidepanelSettings {
    /** Document unique identifier. */
    NoteId: string;

    /** Unique Id for all indexes of the document. */
    UniversalId: string;

    /** (OPTIONAL) Flag that prevents on-click events. */
    disableClick?: boolean;
}
